var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57984 6C5.70286 5.98891 5.81715 5.93176 5.89984 5.84L10.7898 1.07C10.8532 1.01504 10.9046 0.9476 10.9407 0.871892C10.9768 0.796185 10.997 0.713839 10.9998 0.63C11.004 0.549679 10.992 0.469337 10.9645 0.39375C10.937 0.318163 10.8946 0.248873 10.8398 0.19C10.785 0.130551 10.7185 0.0830081 10.6446 0.0503232C10.5706 0.0176383 10.4907 0.000509314 10.4098 0C10.3319 0.000827085 10.2551 0.0181931 10.1844 0.0509482C10.1137 0.0837032 10.0508 0.1311 9.99984 0.19L5.49984 4.58L0.999835 0.19C0.947332 0.132942 0.884097 0.0867935 0.813747 0.0541918C0.743396 0.0215902 0.667308 0.00317523 0.589835 0C0.508967 0.000509314 0.429066 0.0176383 0.355095 0.0503232C0.281123 0.0830081 0.214661 0.130551 0.159835 0.19C0.105037 0.248873 0.0626337 0.318163 0.0351474 0.39375C0.00766112 0.469337 -0.00434748 0.549679 -0.000164553 0.63C0.00404663 0.712129 0.0248207 0.792557 0.0609089 0.866452C0.0969972 0.940347 0.147654 1.00618 0.209835 1.06L5.09984 5.83C5.15914 5.89636 5.23419 5.94671 5.31808 5.97642C5.40197 6.00613 5.49199 6.01424 5.57984 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown);
export default __webpack_public_path__ + "static/media/Arrowdown.47cd133a9a8329a5f2a148f26d22332f.svg";
export { ForwardRef as ReactComponent };